import React, { Component, createRef } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import './toggle.css';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';
import LinkModal from './../LinkModal';

class Toggle extends Component {

    constructor(props) {
        super(props);

        this.questionInputRef = createRef();
        this.descriptionInputRef = createRef();

        this.state = {
            question: this.props.initialValues.label || 'Do you agree?',
            description: this.props.initialValues.description || '',
            checked: false,
            required: this.props.initialValues.isRequired || false,
            requiredError: (this.props.initialValues.isRequired || false),
            isLinkModalOpen: false,
            linkTargetInfo: null,
        };
    }

    updateInputPropsInStore = () => {
        const inputProps = {
            _value: String(this.state.checked),
            _hasValidationErrors: this.state.requiredError,
            label: this.state.question,
            description: this.state.description,
            isRequired: this.state.required,
            type: this.props.initialValues.type
        };
        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    };

    componentDidUpdate() {
        this.updateInputPropsInStore();
    };

    setQuestion = (e) => {
        this.setState({ question: e.target.value });
    };

    setDescription = (e) => {
        this.setState({ description: e.target.value });
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked });
    };

    onToggle = (e) => {
        this.setState({
            checked: e.target.checked,
            requiredError: !e.target.checked
        });
    };

    handleLinkIconClick = (targetInputType) => {
        const targetRef = targetInputType === 'question' ? this.questionInputRef : this.descriptionInputRef;
        const targetStateValue = this.state[targetInputType];

        if (targetRef.current) {
            const inputElement = targetRef.current;
            const { selectionStart, selectionEnd } = inputElement;

            if (selectionStart !== selectionEnd) {
                const selectedText = targetStateValue.substring(selectionStart, selectionEnd);
                this.setState({
                    isLinkModalOpen: true,
                    linkTargetInfo: {
                        type: targetInputType,
                        start: selectionStart,
                        end: selectionEnd,
                        text: selectedText,
                    }
                });
            } else {
                alert('Please select some text in the "' + targetInputType + '" field first.');
            }
        }
    };

    handleModalSubmit = (url) => {
        const { linkTargetInfo } = this.state;
        if (!linkTargetInfo || !url) {
            this.closeLinkModal();
            return;
        }

        const { type, start, end, text } = linkTargetInfo;
        const currentValue = this.state[type];

        const formattedUrl = (url.startsWith('http://') || url.startsWith('https://')) ? url : `https://${url}`;
        const linkMarkdown = `[${text}](${formattedUrl})`;
        const newValue =
            currentValue.substring(0, start) +
            linkMarkdown +
            currentValue.substring(end);

        this.setState({ [type]: newValue }, this.closeLinkModal);
    };

    closeLinkModal = () => {
        this.setState({ isLinkModalOpen: false, linkTargetInfo: null });
    };


    render() {
        const { color, textColor, isResultInput } = this.props;
        const showRequiredError = this.state.required && !this.state.checked;

        return (
            <>
                <AppInputWrapper
                    color={textColor}
                    label={' '}
                    required={this.state.required}
                    requiredError={this.state.requiredError}
                >
                    <div className="toggle-question">
                        <span
                            className="input-label-text"
                            dangerouslySetInnerHTML={{ __html: this.state.question }}
                        ></span>

                        <label className="switch">

                            <input className="toggle-btn" onChange={this.onToggle} type="checkbox" />
                            {
                                this.state.checked ?
                                    <span style={{ 'backgroundColor': color }} className="slider round"/>
                                    :
                                    <span className="slider round"/>
                            }
                        </label>
                    </div>
                    {
                        this.state.description &&
                        <p className="toggle-description">{ this.state.description }</p>
                    }
                </AppInputWrapper>

                {!isResultInput && (
                    <AppCollapsible>
                        <div className="settings-container">

                            <div className="input-with-icon">
                                <label>
                                    <input
                                        ref={this.questionInputRef}
                                        value={this.state.question}
                                        onChange={this.setQuestion}
                                        type="text"
                                    />
                                    label
                                </label>
                                <button
                                    type="button"
                                    onClick={() => this.handleLinkIconClick('question')}
                                    className="link-icon-button"
                                    title="Insert Link"
                                >
                                    🔗
                                </button>
                            </div>

                            <div className="input-with-icon">
                                <label>
                                <textarea
                                    ref={this.descriptionInputRef}
                                    value={this.state.description}
                                    onChange={this.setDescription}
                                    rows={3}
                                />
                                    description
                                </label>
                            </div>

                            <label className="checkbox-label">
                                <input
                                    checked={this.state.required}
                                    onChange={this.setRequired}
                                    type="checkbox"
                                />
                                Required
                            </label>
                        </div>
                    </AppCollapsible>
                )}

                {this.state.isLinkModalOpen && (
                    <LinkModal
                        selectedText={this.state.linkTargetInfo && this.state.linkTargetInfo.text}
                        onSubmit={this.handleModalSubmit}
                        onClose={this.closeLinkModal}
                    />
                )}
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Toggle);
